<div class="sourcePanel h-100">
    <div class="d-flex justify-content-between align-items-center bg-white block_head">
        <h4>Source</h4>
        <a (click)="closePanel.emit()" class="cursor-pointer">
            <img src="/assets/images/close_icon.svg" alt="Close">
        </a>
    </div>
    <div class="sourcePanelCont">
        <!-- source_list -->
        @for (item of sources(); track $index) {
        <a class="source_list" href="{{item.url}}" target="_blank">
            <div class="d-flex align-items-center mb-2">
                <span class="d-inline-flex logo-block" [class.default]="!item.image || (item.image && item.image.includes('default-logo.svg')) ">
                    <img [src]="item.image || '/assets/images/default-logo.svg'" alt="Site Logo" />
                </span>
                {{item.title ? item.infoTitle : item.info_title ?  item.info_title : item.sourceTitle}}
            </div>
            <h5 class="mb-2">{{(!item.title && item.infoTitle) ? item.infoTitle : item.source_title ? item.source_title : item.title}}</h5>
        </a>
        }
    </div>
</div>